export default "__VITE_ASSET__DbCnl3M5__"